import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './ObsequiosEjecutivo.css';
import logo from '../assets/Logo.png';
import logoG360 from "../assets/Logo_G360_Black.png";
import imagenDerecha from '../assets/Obsequios.jpg';
import {
  FiSearch,
  FiGift,
  FiHeart,
  FiBookOpen,
  FiCalendar,
  FiSend
} from "react-icons/fi";
import { toast } from "react-toastify";
import PageTitle from "../components/PageTitle";

const API = process.env.REACT_APP_API_URL;

function ObsequiosEjecutivo() {
  const [cedulaEjecutivo, setCedulaEjecutivo] = useState('');
  const [cedulaAsociado, setCedulaAsociado] = useState('');
  const [ejecutivoValido, setEjecutivoValido] = useState(false);
  const [asociado, setAsociado] = useState(null);
  const [obsequiosAsociado, setObsequiosAsociado] = useState([]);
  const [obsequioSeleccionado, setObsequioSeleccionado] = useState(null);
  const [codigoWhatsapp, setCodigoWhatsapp] = useState(null);
  const [codigoIngresado, setCodigoIngresado] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [saludo, setSaludo] = useState("");
  const [timer, setTimer] = useState(0);
  const [, setIntervalId] = useState(null);
  const [datosEjecutivo, setDatosEjecutivo] = useState(null);
  const [entregasHabilitadas, setEntregasHabilitadas] = useState(true);
  const [verificandoCodigo, setVerificandoCodigo] = useState(false);

  // --------------------------
  // SALUDO DINÁMICO
  // --------------------------
  useEffect(() => {
    const h = new Date().getHours();
    if (h < 12) setSaludo("Buenos días");
    else if (h < 18) setSaludo("Buenas tardes");
    else setSaludo("Buenas noches");
  }, []);

  useEffect(() => {
    const cargarConfig = async () => {
      try {
        const res = await axios.get(`${API}/api/obsequios/config-entregas`);
        setEntregasHabilitadas(res.data.entregasHabilitadas);
      } catch (err) {
        console.log("Error cargando config");
      }
    };

    cargarConfig();
  }, []);


  // --------------------------
  // VALIDAR EJECUTIVO
  // --------------------------
  const validarEjecutivo = async () => {
    try {
      const res = await axios.get(`${API}/api/obsequios/${cedulaEjecutivo}`);

      if (res.data.autorizado) {
        setEjecutivoValido(true);
        setDatosEjecutivo(res.data.ejecutivo);

        const primerNombre = res.data.ejecutivo.nombre.split(" ")[0];
        toast.success(`¡${primerNombre}, has iniciado sesión correctamente!`);
      } else {
        toast.error("Ejecutivo no autorizado");
      }
    } catch (error) {
      toast.error("El número ingresado no se encuentra registrado");
    }
  };

  const obtenerMensajeError = (error, mensajePredeterminado) => {
    if (!error.response) {
      return "No fue posible conectarse con el servidor. Verifica la conexión e intenta nuevamente.";
    }

    const data = error.response.data || {};

    if (data.message) {
      return data.message;
    }

    switch (data.motivo) {
      case "NO_ES_ASOCIADO":
        return "La identificación no está registrada como asociada al Fondo Manpower.";

      case "ASOCIACION_NO_ACTIVA":
        return data.estadoAsociado
          ? `La persona tiene el estado "${data.estadoAsociado}" y no está habilitada para recibir el obsequio.`
          : "La persona no tiene una asociación activa.";

      case "SIN_CONTRATO_ACTIVO":
        return "La persona está asociada, pero no tiene un contrato laboral activo.";

      case "SIN_OBSEQUIO_ASIGNADO":
        return "La persona está activa, pero no se encuentra incluida en la base de beneficiarios del obsequio.";

      default:
        return mensajePredeterminado;
    }
  };


  // --------------------------
  // BUSCAR ASOCIADO
  // --------------------------
  const buscarAsociado = async () => {
    const cedulaConsultada = String(
      cedulaAsociado || ""
    )
      .replace(/\D/g, "")
      .trim();

    setAsociado(null);
    setObsequiosAsociado([]);
    setObsequioSeleccionado(null);
    setCodigoWhatsapp(null);
    setCodigoIngresado("");

    if (!cedulaConsultada) {
      toast.warn("Ingrese la cédula del asociado.");
      return;
    }

    try {
      const validacion = await axios.get(
        `${API}/api/obsequios/asociado/${cedulaConsultada}`
      );

      if (!validacion.data?.activo) {
        toast.error(
          validacion.data?.message ||
          "La persona no cumple las condiciones para recibir el obsequio."
        );

        return;
      }

      if (!validacion.data?.tieneObsequio) {
        toast.info(
          validacion.data?.message ||
          "La persona no tiene un obsequio asignado."
        );

        return;
      }

      const res = await axios.get(
        `${API}/api/obsequios/listar`
      );

      const registros = (res.data || []).filter(
        (registro) =>
          String(registro.Cedula || "").trim() ===
          cedulaConsultada
      );

      if (registros.length === 0) {
        toast.info(
          "La persona está activa, pero no se encuentra incluida en la base de beneficiarios de obsequios."
        );

        return;
      }

      setCedulaAsociado(cedulaConsultada);
      setAsociado(registros[0]);
      setObsequiosAsociado(registros);
    } catch (error) {
      console.error(
        "Error buscando asociado:",
        error.response?.data || error
      );

      toast.error(
        obtenerMensajeError(
          error,
          "No fue posible consultar al asociado."
        )
      );
    }
  };


  // --------------------------
  // SELECCIONAR OBSEQUIO
  // --------------------------
  const iniciarEntrega = (item) => {
    if (codigoWhatsapp) return; // bloqueo por proceso activo
    setObsequioSeleccionado(item);
    setCodigoWhatsapp(null);
    setCodigoIngresado("");
  };


  // --------------------------
  // ENVIAR CODIGO WHATSAPP
  // --------------------------
  const enviarCodigoWhatsapp = async (item) => {

    if (timer > 0) return;

    try {
      setEnviando(true);
      toast.info("Enviando código por WhatsApp...");

      const response = await axios.post(
        `${API}/api/obsequios/enviar-codigo-whatsapp`,
        {
          asociado: cedulaAsociado,
          ejecutivo: cedulaEjecutivo,
          obsequio: item.Obsequio
        }
      );

      setCodigoWhatsapp(response.data.codigo);
      toast.success("Código enviado correctamente");

      // TIMER
      setTimer(60);
      const id = setInterval(() => {
        setTimer(prev => {
          if (prev <= 1) {
            clearInterval(id);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      setIntervalId(id);

    } catch (error) {
      console.error(
        "Error enviando código:",
        error.response?.data || error
      );

      toast.error(
        obtenerMensajeError(
          error,
          "No fue posible enviar el código de verificación."
        )
      );
    } finally {
      setEnviando(false);
    }
  };


  // --------------------------
  // VERIFICAR CODIGO
  // --------------------------
  const verificarCodigo = async (
    item,
    codigoAValidar = codigoIngresado
  ) => {
    const codigoFinal = String(codigoAValidar || "").trim();

    if (verificandoCodigo) {
      return;
    }

    if (codigoFinal.length !== 6) {
      toast.warn("Ingrese los seis dígitos del código.");
      return;
    }

    if (codigoFinal !== String(codigoWhatsapp)) {
      toast.error("El código ingresado no es correcto.");
      return;
    }

    try {
      setVerificandoCodigo(true);

      const response = await axios.post(
        `${API}/api/obsequios/marcar-entregado`,
        {
          cedula: cedulaAsociado,
          ejecutivo: cedulaEjecutivo,
          obsequio: item.Obsequio,
          codigoEntrega: codigoFinal,
          metodoEntrega: "WhatsApp",
          observacionEntrega:
            "Entrega confirmada mediante código enviado por WhatsApp.",
        }
      );

      toast.success(
        response.data?.message ||
        "Entrega confirmada correctamente."
      );

      setObsequioSeleccionado(null);
      setCodigoWhatsapp(null);
      setCodigoIngresado("");
      setTimer(0);

      await buscarAsociado();
    } catch (error) {
      console.error(
        "Error verificando entrega:",
        error.response?.data || error
      );

      toast.error(
        obtenerMensajeError(
          error,
          "No fue posible confirmar la entrega."
        )
      );
    } finally {
      setVerificandoCodigo(false);
    }
  };


  const iconosObsequio = {
    "Cumpleaños": FiCalendar,
    "Amor y Amistad": FiHeart,
    "Navidad": FiGift,
    "Kit Escolar": FiBookOpen,
  };

  const limpiarTodo = () => {
    setAsociado(null);
    setObsequiosAsociado([]);
    setObsequioSeleccionado(null);
    setCodigoWhatsapp(null);
    setCodigoIngresado("");
    setTimer(0);
    setCedulaAsociado("");
    toast.info("Ya puedes realizar una nueva consulta.");
  };

  return (

    <>

      <PageTitle title="Entregas" />

      <div className="obsequios-ejecutivo">

        <div className="obsequios-ejecutivo-left">
          {/* Logo */}
          <div className="login-logo">
            <img
              src={logoG360}
              alt="Logo Gestión360"
              className="empresa-logo g360-logo"
            />

            <div className="logo-divider"></div>

            <img
              src={logo}
              alt="Logo Fondo Manpower"
              className="empresa-logo"
            />


          </div>

          <div className="obsequios-ejecutivo-body">
            <div className="obsequios-ejecutivo-content">

              <h1 className="welcome-text">
                {ejecutivoValido && datosEjecutivo
                  ? `¡Hola, ${datosEjecutivo.nombre.split(" ")[0]}!`
                  : `¡${saludo}! Bienvenido a Entregas360`}
              </h1>


              <p className="subtext">¡Legaliza las entregas de obsequios de tus colaboradores!</p>


              {/* VALIDAR EJECUTIVO */}
              {!ejecutivoValido ? (
                <div className="buscar-asociado-wrapper">

                  <div className="buscar-asociado-input">
                    <FiSearch className="buscar-icono" />
                    <input
                      type="text"
                      placeholder="Ingrese su número de autorización"
                      value={cedulaEjecutivo}
                      onChange={(e) => setCedulaEjecutivo(e.target.value)}
                    />
                  </div>

                  <button className="btn purple-btn buscar-btn" onClick={validarEjecutivo}>
                    Ingresar
                  </button>

                </div>
              ) : (

                <div className="buscar-asociado-wrapper">
                  <div className="buscar-asociado-input">
                    <FiSearch className="buscar-icono" />
                    <input
                      type="text"
                      placeholder="Ingrese la cédula del asociado"
                      value={cedulaAsociado}
                      onChange={(e) => setCedulaAsociado(e.target.value)}
                    />
                  </div>

                  <button
                    className="btn purple-btn buscar-btn"
                    onClick={buscarAsociado}
                  >
                    Buscar
                  </button>

                  {asociado && (
                    <button
                      className="btn blue-btn limpiar-btn"
                      onClick={limpiarTodo}
                    >
                      Limpiar
                    </button>
                  )}

                </div>
              )}



              {/* DATOS DEL ASOCIADO */}
              {asociado && (
                <div className="asociado-info">
                  <h3>Datos del asociado</h3>

                  <div className="asociado-grid">
                    <div className="asociado-item"><label>Nombre</label><span>{asociado.Nombre}</span></div>
                    <div className="asociado-item"><label>Teléfono</label><span>{asociado.Telefono}</span></div>
                    <div className="asociado-item"><label>Zona de Entrega</label><span>{asociado.Ciudad}</span></div>
                    <div className="asociado-item"><label>Empresa</label><span>{asociado.Empresa}</span></div>
                  </div>
                </div>
              )}


              {/* ------------------------------ */}
              {/*       OBSEQUIOS DISPONIBLES     */}
              {/* ------------------------------ */}

              {obsequiosAsociado.length > 0 && (
                <div className="obsequio-lista">
                  <h3>Obsequios asignados</h3>

                  <div className="obsequios-grid">
                    {obsequiosAsociado.map((item) => {
                      const estaSeleccionado =
                        obsequioSeleccionado?._id === item._id;

                      const procesoActivo =
                        codigoWhatsapp !== null;

                      const IconoObsequio =
                        iconosObsequio[item.Obsequio] || FiGift;

                      const yaEntregado =
                        item.Estado_Entrega === "Entregado";

                      return (
                        <div
                          key={item._id}
                          className={
                            "ob-card " +
                            (estaSeleccionado
                              ? "ob-card-active "
                              : "") +
                            (!estaSeleccionado && procesoActivo
                              ? "ob-card-disabled "
                              : "")
                          }
                          onClick={() => {
                            if (!procesoActivo) {
                              iniciarEntrega(item);
                            }
                          }}
                        >
                          <div className="ob-card-circle">
                            <IconoObsequio
                              size={22}
                              aria-hidden="true"
                            />
                          </div>

                          <div className="ob-card-title">
                            {item.Obsequio}
                          </div>

                          {yaEntregado ? (
                            <span className="ob-badge ob-badge-green">
                              Entregado
                            </span>
                          ) : (
                            <span className="ob-badge ob-badge-gray">
                              Pendiente
                            </span>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* ===================================== */}
              {/* ACCIONES DEL OBSEQUIO SELECCIONADO   */}
              {/* ===================================== */}

              {obsequioSeleccionado && (
                <div className="obsequio-proceso">
                  <div className="divider"></div>

                  {/* ===================================== */}
                  {/* OBSEQUIO PENDIENTE                    */}
                  {/* ===================================== */}

                  {obsequioSeleccionado.Estado_Entrega !== "Entregado" && (
                    <>
                      {!codigoWhatsapp && (
                        <>
                          {entregasHabilitadas ? (
                            <div className="obsequio-accion-envio">
                              <div className="obsequio-accion-info">
                                <FiSend size={20} />

                                <div>
                                  <strong>
                                    Confirmar entrega de{" "}
                                    {obsequioSeleccionado.Obsequio}
                                  </strong>

                                  <span>
                                    Se enviará un código de verificación al WhatsApp
                                    registrado del asociado.
                                  </span>
                                </div>
                              </div>

                              <button
                                onClick={() =>
                                  enviarCodigoWhatsapp(obsequioSeleccionado)
                                }
                                className="btn green-btn enviar-codigo-btn"
                                disabled={timer > 0 || enviando}
                              >
                                {enviando
                                  ? "Enviando código..."
                                  : timer > 0
                                    ? `Podrás reenviar el código en ${String(
                                      Math.floor(timer / 60)
                                    ).padStart(2, "0")}:${String(
                                      timer % 60
                                    ).padStart(2, "0")}`
                                    : "Enviar código por WhatsApp"}
                              </button>
                            </div>
                          ) : (
                            <div className="entregas-inhabilitadas">
                              <FiGift size={20} />

                              <div>
                                <strong>Entregas inhabilitadas</strong>

                                <span>
                                  En este momento no se encuentran habilitadas las
                                  entregas de obsequios.
                                </span>
                              </div>
                            </div>
                          )}
                        </>
                      )}

                      {/* ===================================== */}
                      {/* CÓDIGO OTP                            */}
                      {/* ===================================== */}

                      {codigoWhatsapp && (
                        <div className="otp-wrapper">
                          <div className="otp-header">
                            <FiSend size={20} />

                            <div>
                              <strong>Código de verificación enviado</strong>

                              <span>
                                Ingrese los seis dígitos recibidos por WhatsApp.
                                Al completar el código se validará automáticamente.
                              </span>
                            </div>
                          </div>

                          <div className="codigo-otp">
                            {[0, 1, 2, 3, 4, 5].map((index) => (
                              <input
                                key={index}
                                id={`otp-${index}`}
                                type="text"
                                inputMode="numeric"
                                autoComplete={
                                  index === 0
                                    ? "one-time-code"
                                    : "off"
                                }
                                maxLength={1}
                                className="codigo-otp-modern"
                                value={codigoIngresado[index] || ""}
                                disabled={verificandoCodigo}
                                onChange={(e) => {
                                  const value = e.target.value
                                    .replace(/\D/g, "")
                                    .slice(-1);

                                  const caracteres =
                                    codigoIngresado.split("");

                                  caracteres[index] = value;

                                  const codigoCompleto =
                                    caracteres.join("");

                                  setCodigoIngresado(codigoCompleto);

                                  if (value && index < 5) {
                                    document
                                      .getElementById(
                                        `otp-${index + 1}`
                                      )
                                      ?.focus();
                                  }

                                  if (
                                    value &&
                                    index === 5 &&
                                    codigoCompleto.length === 6
                                  ) {
                                    verificarCodigo(
                                      obsequioSeleccionado,
                                      codigoCompleto
                                    );
                                  }
                                }}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "Backspace" &&
                                    !codigoIngresado[index] &&
                                    index > 0
                                  ) {
                                    document
                                      .getElementById(
                                        `otp-${index - 1}`
                                      )
                                      ?.focus();
                                  }
                                }}
                                onPaste={(e) => {
                                  e.preventDefault();

                                  const codigoPegado =
                                    e.clipboardData
                                      .getData("text")
                                      .replace(/\D/g, "")
                                      .slice(0, 6);

                                  setCodigoIngresado(codigoPegado);

                                  if (codigoPegado.length === 6) {
                                    document
                                      .getElementById("otp-5")
                                      ?.focus();

                                    verificarCodigo(
                                      obsequioSeleccionado,
                                      codigoPegado
                                    );
                                  }
                                }}
                              />
                            ))}
                          </div>

                          <div className="otp-estado-validacion">
                            {verificandoCodigo
                              ? "Validando código..."
                              : `${codigoIngresado.length}/6 dígitos ingresados`}
                          </div>

                          <button
                            className="btn-II blue-btn confirmar-codigo-btn"
                            onClick={() =>
                              verificarCodigo(
                                obsequioSeleccionado,
                                codigoIngresado
                              )
                            }
                            disabled={
                              verificandoCodigo ||
                              codigoIngresado.length !== 6
                            }
                          >
                            {verificandoCodigo
                              ? "Confirmando entrega..."
                              : "Confirmar código"}
                          </button>
                        </div>
                      )}
                    </>
                  )}

                  {/* ===================================== */}
                  {/* OBSEQUIO YA ENTREGADO                 */}
                  {/* ===================================== */}

                  {obsequioSeleccionado.Estado_Entrega === "Entregado" && (
                    <div className="detalle-entrega-ejecutivo">
                      <div className="detalle-entrega-header">
                        <div className="detalle-entrega-icon">
                          <FiGift size={20} />
                        </div>

                        <div>
                          <strong>Obsequio entregado</strong>

                          <span>
                            Esta entrega ya fue confirmada. A continuación
                            puede consultar su trazabilidad.
                          </span>
                        </div>

                        <span className="detalle-entrega-badge">
                          Entregado
                        </span>
                      </div>

                      <div className="detalle-entrega-grid">
                        <div className="detalle-entrega-item">
                          <label>Obsequio</label>
                          <span>
                            {obsequioSeleccionado.Obsequio || "—"}
                          </span>
                        </div>

                        <div className="detalle-entrega-item">
                          <label>Fecha de entrega</label>

                          <span>
                            {obsequioSeleccionado.fechaEntrega
                              ? new Date(
                                obsequioSeleccionado.fechaEntrega
                              ).toLocaleString("es-CO", {
                                dateStyle: "medium",
                                timeStyle: "short",
                              })
                              : "—"}
                          </span>
                        </div>

                        <div className="detalle-entrega-item">
                          <label>Entregado por</label>

                          <span>
                            {obsequioSeleccionado.ejecutivo || "—"}
                          </span>
                        </div>

                        <div className="detalle-entrega-item">
                          <label>Identificación del responsable</label>

                          <span>
                            {obsequioSeleccionado.cedulaEjecutivo ||
                              "—"}
                          </span>
                        </div>

                        <div className="detalle-entrega-item">
                          <label>Método</label>

                          <span>
                            {obsequioSeleccionado.metodoEntrega ||
                              "No registrado"}
                          </span>
                        </div>

                        <div className="detalle-entrega-item">
                          <label>Código de entrega</label>

                          <span>
                            {obsequioSeleccionado.codigoEntrega ||
                              "No aplica"}
                          </span>
                        </div>

                        {obsequioSeleccionado.observacionEntrega && (
                          <div className="detalle-entrega-item detalle-entrega-observacion">
                            <label>Observaciones</label>

                            <span>
                              {obsequioSeleccionado.observacionEntrega}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )}


            </div>
          </div>

          <div className="login-footer">
            <p>¿Necesitas ayuda? <a href="https://api.whatsapp.com/send?phone=573054339230">Contacta con soporte</a></p>
          </div>
        </div>

        <div className="obsequios-ejecutivo-right">
          <img src={imagenDerecha} alt="Obsequios" />
        </div>
      </div>

    </>

  );

}

export default ObsequiosEjecutivo;
